import React, { useState } from "react";
import { NavLink, Route, Link, Redirect } from "react-router-dom";
import axios from "axios";

import Home from "../components/AdminPanel/Home/Home";
import Shops from "../components/AdminPanel/Shops/Shops";

import ActiveShops from "../components/AdminPanel/Shops/ActiveShops";
import ShopsRequest from "../components/AdminPanel/Shops/ShopsRequest";
import BlockShops from "../components/AdminPanel/Shops/BlockShops";
import Products from "../components/AdminPanel/Products/Products";
import Categories from "../components/AdminPanel/Categories/Categories";
import Brands from "../components/AdminPanel/Brands/Brands";
import SignModal from "../components/Modals/SignModal";

import { server } from "../utills/utils";

import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 100vh;
  background: #f8f8f8;
`;
const AdminNav = styled.div`
  width: 100%;
  height: 60px;
  background: black;
  border-bottom: 1px solid #eee;
  position: fixed;
`;
const AdminContent = styled.div`
  width: 85%;
  margin-left: 7.5%;
  height: auto;
  padding-top: 90px;
`;
const LeftNav = styled.div`
  width: 18%;
  height: 87vh;
  float: left;
`;
const NavItem = styled(NavLink)`
  background: none;
  display: block;
  margin-bottom: 10px;
  text-align: center;
  padding: 10px 0;
  border-radius: 5px;
  text-decoration: none;
  border: 1px solid #cccc;
  font-weight: 500;
  color: black;
`;
const MainBody = styled.div`
  width: 80%;
  height: 87vh;
  float: right;
`;
const Panel = styled(Link)`
  float: left;
  color: white;
  margin-left: 7.5%;
  font-size: 1.3em;
  font-weight: bold;
  padding: 13px 0;
  text-decoration: none;
`;
const LogoutButton = styled.button`
  float: right;
  padding: 8px 20px;
  margin: 13px 7.5% 0 0;
  cursor: pointer;
`;
const Input = styled.input`
  width: 95.7%;
  padding: 13px 10px;
  border: 1px solid #eee;
  border-radius: 5px;
  outline: none;
  margin: 5px 0;
  font-size: 1em;
`;
const SubmitButton = styled.button`
  width: 100.4%;
  padding: 13px 10px;
  border: 1px solid #da340e;
  border-radius: 5px;
  outline: none;
  margin: 5px 0;
  font-size: 1em;
  background: #da340e;
  color: white;
  font-weight: bold;
  cursor: pointer;
`;

const ErrorMessage = styled.div`
  width: 100%;
  background: rgba(255, 0, 0, 0.089);
  padding: 13px 0;
  color: black;
  border-radius: 5px;
`;

function Admin() {
  const [logModal, setLogModal] = useState(true);
  const [redirect, setRedirect] = useState(null);
  const [message, setMessage] = useState("");
  const [key, setKey] = useState("");

  const loginHandler = async () => {
    if (key) {
      try {
        setMessage("");
        await axios
          .post(server, {
            query: `
            query{
              adminLogin(key:"${key}"){
                success
              }
            }
          `,
          })
          .then((res) => {
            if (res) {
              if (res.data.data.adminLogin.success) {
                setRedirect(null);
                setLogModal(!logModal);
                setRedirect(<Redirect to="/admin" />);
                setKey("");
              } else {
                setMessage("Wrong secret key!");
              }
            }
          });
      } catch (error) {
        console.log(error);
      }
    }
  };
  const keyChangeHandler = (e) => {
    setKey(e.target.value);
  };
  return (
    <Container>
      {redirect}
      <SignModal show={logModal} admin={true}>
        <div style={{ width: "100%", padding: "20px" }}>
          <h2 style={{ padding: "0", margin: "0 0 10px 0", fontWeight: "500" }}>
            Enter Secret Key
          </h2>
          {message && (
            <ErrorMessage>
              <p style={{ padding: "0", margin: "0" }}>{message}</p>
            </ErrorMessage>
          )}
          <Input
            type="password"
            name="key"
            onChange={(e) => keyChangeHandler(e)}
            placeholder="Secret key"
          />
          <SubmitButton onClick={loginHandler}>Submit</SubmitButton>
        </div>
      </SignModal>
      <AdminNav>
        <Panel to="/admin">Admin Panel</Panel>
        <LogoutButton>Log out</LogoutButton>
      </AdminNav>
      <AdminContent>
        <LeftNav>
          <NavItem to="/admin" exact activeStyle={{ background: "white" }}>
            Home
          </NavItem>
          <NavItem to="/admin/shops" activeStyle={{ background: "white" }}>
            Shops
          </NavItem>
          {/* <NavItem
            to="/admin/active-shops"
            activeStyle={{ background: "white" }}
          >
            Active Shops
          </NavItem> */}
          {/* <NavItem
            to="/admin/active-shops"
            activeStyle={{ background: "white" }}
          >
            Subscription off Shops
          </NavItem>
          <NavItem
            to="/admin/block-shops"
            exact
            activeStyle={{ background: "white" }}
          >
            Block Shops
          </NavItem> */}
          <NavItem
            to="/admin/products"
            exact
            activeStyle={{ background: "white" }}
          >
            Products
          </NavItem>
          {/* <NavItem
            to="/admin/sales"
            exact
            activeStyle={{ background: "white" }}
          >
            Sales
          </NavItem> */}
          <NavItem
            to="/admin/users"
            exact
            activeStyle={{ background: "white" }}
          >
            Users
          </NavItem>
          <NavItem
            to="/admin/categories"
            exact
            activeStyle={{ background: "white" }}
          >
            Categories
          </NavItem>
          {/* <NavItem
            to="/admin/brands"
            exact
            activeStyle={{ background: "white" }}
          >
            Brands
          </NavItem> */}
          {/* <NavItem
            to="/admin/block-users"
            exact
            activeStyle={{ background: "white" }}
          >
            Block Users
          </NavItem> */}
        </LeftNav>
        <MainBody>
          <Route path="/admin" exact component={Home} />
          <Route path="/admin/shops" component={Shops} />
          <Route path="/admin/active-shops" exact component={ActiveShops} />
          <Route path="/admin/block-shops" exact component={BlockShops} />
          <Route path="/admin/products" exact component={Products} />
          <Route path="/admin/categories" exact component={Categories} />
          {/* <Route path="/admin/brands" exact component={Brands}/> */}

          {/* 
                   <Route path="/merchant/products" exact component={Products} />
                   <Route path="/merchant/orders" component={Orders}/>
                   <Route path="/merchant/notifications" exact component={Notifications}/>
                   <Route path="/merchant/settings" exact component={Settings}/>
                   <Route path="/merchant/sales" exact component={Sales}/> */}
        </MainBody>
      </AdminContent>
    </Container>
  );
}

export default Admin;
